import { Element } from '../../../../html/element'
import { TYPE_PERIOD_TIME, TYPE_SCORE_VAlUE } from '../../constant'
import { Transcript } from './components/Transcript'
import classes from './scoreLevel.module.scss'

export const CreditScore = ({ data }) => {
  return (
    <>
      <Element
        style={{ borderColor: '#D5D5D5' }}
        className={classes.contentScore}
      >
        <Transcript
          data={data}
          typePeriod={TYPE_SCORE_VAlUE.CREDIT_SCORE}
          typePeriodTime={TYPE_PERIOD_TIME.CURRENT}
        />
        <Transcript
          data={data}
          isRight
          typePeriod={TYPE_SCORE_VAlUE.CREDIT_SCORE}
          typePeriodTime={TYPE_PERIOD_TIME.PREVIOUS}
        />
      </Element>
    </>
  )
}
